import { defineMessages } from 'react-intl';

export const paymentDeclined = defineMessages({
    heading: {
        id: 'payment.paymentDeclined.heading',
        description: 'Error heading for payment declined - NOT CONFIGURABLE',
        defaultMessage: 'Payment Declined',
        meta: {
            editable: false
        }
    },
    message: {
        id: 'payment.paymentDeclined.message',
        description: 'Error message for payment declined - NOT CONFIGURABLE',
        defaultMessage: 'We\'re sorry, this transaction has been declined. '
            + 'Please check your credit card information and resubmit. '
            + 'If you continue to have this problem, please contact customer support.',
        meta: {
            editable: false
        }
    }
});


export const transactionDeclined = defineMessages({
    heading: {
        id: 'payment.transactionDeclined.heading',
        description: 'Error heading for transaction declined - NOT CONFIGURABLE',
        defaultMessage: 'Transaction Declined',
        meta: {
            editable: false
        }
    },
    message: {
        id: 'payment.transactionDeclined.message',
        description: 'Error message for transaction declined - NOT CONFIGURABLE',
        defaultMessage: 'You have reached the daily purchase limit for an individual. Please contact customer support.',
        meta: {
            editable: false
        }
    }
});

export const limitReached = defineMessages({
    heading: {
        id: 'payment.limitReached.heading',
        description: 'Error heading for transaction declined - NOT CONFIGURABLE',
        defaultMessage: 'PLEASE CORRECT THE ISSUES BELOW TO CONTINUE.',
        meta: {
            editable: false
        }
    },
    message: {
        id: 'payment.limitReached.message',
        description: 'Error message for fincen limit reached - NOT CONFIGURABLE',
        defaultMessage: 'You have reached the daily purchase limit for an individual. Please contact customer support.',
        meta: {
            editable: false
        }
    }
});

export const promoExpired = defineMessages({
    heading: {
        id: 'payment.promoExpired.heading',
        description: 'The promo that has been applied to this cart has expired.',
        defaultMessage: 'PROMO EXPIRED',
        meta: {
            editable: false
        }
    },
    message: {
        id: 'payment.promoExpired.message',
        description: 'The promo that has been applied to this cart has expired.',
        defaultMessage: 'We\'re sorry, the promotion has expired. Would you like to go back and edit your '
        + 'cart or complete your purchase without the promotion?',
        meta: {
            editable: false
        }
    },
    messageAlt: {
        id: 'payment.promoExpired.messageAlt',
        description: 'The promo that has been applied to this cart has expired.',
        defaultMessage: 'We\'re sorry the promotion has expired. Would you like to go back and edit your cart'
        + ' or retry your payment without the promotion?',
        meta: {
            editable: false
        }
    }
});

export const promoLimited = defineMessages({
    heading: {
        id: 'payment.promoLimited.heading',
        description: 'The purchaser has reached the redemption limits for the promotion applied to their cart.',
        defaultMessage: 'PROMO LIMITED',
        meta: {
            editable: false
        }
    },
    message: {
        id: 'payment.promoLimited.message',
        description: 'The purchaser has reached the redemption limits for the promotion applied to their cart.',
        defaultMessage: 'You have already redeemed this promotion. Would you like to go back and edit your '
        + 'cart or complete your purchase without the promotion?',
        meta: {
            editable: false
        }
    },
    messageAlt: {
        id: 'payment.promoLimited.messageAlt',
        description: 'The purchaser has reached the redemption limits for the promotion applied to their cart.',
        defaultMessage: 'You have already redeemed this promotion. Would you like to go back and edit your cart or '
        + 'retry your payment without the promotion?',
        meta: {
            editable: false
        }
    }
});

export const mismatchAuthAmount = defineMessages({
    heading: {
        id: 'payment.mismatchAuthAmount.heading',
        description: 'The discount amount submitted does not match the discount amount that the cart qualifies for.',
        defaultMessage: 'There Was A Problem With Your Order',
        meta: {
            editable: false
        }
    },
    message: {
        id: 'payment.mismatchAuthAmount.message',
        description: 'The promo reward amount submitted is more than it should be.',
        defaultMessage: 'Would you like to go back and edit your cart or complete your purchase without the promotion?',
        meta: {
            editable: false
        }
    },
    messageAlt: {
        id: 'payment.mismatchAuthAmount.messageAlt',
        description: 'The promo reward amount submitted is more than it should be.',
        defaultMessage: 'Would you like to go back and edit your cart or retry your payment without the promotion?',
        meta: {
            editable: false
        }
    }
});

export const fieldError = defineMessages({
    heading: {
        id: 'payment.fieldError.heading',
        description: 'Error heading for the field errors occured',
        defaultMessage: 'Error'
    }
});

export const recipientNameExceeded = defineMessages({
    message: {
        id: 'payment.recipientNameExceeded.message',
        description: 'Error message for payment declined upon recipient Name exceeds Max length',
        defaultMessage: 'Recipient name should not exceed 30 characters, please re-enter and submit. ',
        meta: {
            editable: false
        }
    }
});

export const senderNameExceeded = defineMessages({
    message: {
        id: 'payment.senderNameExceeded.message',
        description: 'Error message for payment declined upon sender Name exceeds Max length',
        defaultMessage: 'Sender name should not exceed 30 characters, please re-enter and submit. ',
        meta: {
            editable: false
        }
    }
});

export const firstNameOnCardExceeded = defineMessages({
    message: {
        id: 'payment.firstNameOnCardExceeded.message',
        description: 'Error message for payment declined upon first Name on card exceeds Max length',
        defaultMessage: 'First Name on card should not exceed 15 characters, please re-enter and submit. ',
        meta: {
            editable: false
        }
    }
});

export const lastNameOnCardExceeded = defineMessages({
    message: {
        id: 'payment.lastNameOnCardExceeded.message',
        description: 'Error message for payment declined upon last Name on card exceeds Max length',
        defaultMessage: 'Last Name on card should not exceed 30 characters, please re-enter and submit. ',
        meta: {
            editable: false
        }
    }
});

export const streetOrAddressExceeded = defineMessages({
    message: {
        id: 'payment.streetOrAddressExceeded.message',
        description: 'Error message for payment declined upon street Name exceeds Max length',
        defaultMessage: 'Street or address field should not exceed 100 characters, please re-enter and submit. ',
        meta: {
            editable: false
        }
    }
});

export const apartmentOrHouseNumberExceeded = defineMessages({
    message: {
        id: 'payment.apartmentOrHouseNumberExceeded.message',
        description: 'Error message for payment declined upon House Number exceeds Max length',
        defaultMessage: 'House or apartment number should not exceed 100 characters, please re-enter and submit. ',
        meta: {
            editable: false
        }
    }
});

export const cityNameExceeded = defineMessages({
    message: {
        id: 'payment.cityNameExceeded.message',
        description: 'Error message for payment declined upon city name exceeds Max length',
        defaultMessage: 'City name should not exceed 50 characters, please re-enter and submit. ',
        meta: {
            editable: false
        }
    }
});

export const zipCodeExceeded = defineMessages({
    message: {
        id: 'payment.zipCodeExceeded.message',
        description: 'Error message for payment declined upon Zipcode digits exceeds Max length',
        defaultMessage: 'Postal code should not exceed 10 characters, please re-enter and submit. ',
        meta: {
            editable: false
        }
    }
});

export const idMapper = {
    'purchaserFirstName.exceedsMaxLength': firstNameOnCardExceeded,
    'purchaserLastName.exceedsMaxLength': lastNameOnCardExceeded,
    'streetOrAddress.exceedsMaxLength': streetOrAddressExceeded,
    'apartmentOrHouseNumber.exceedsMaxLength': apartmentOrHouseNumberExceeded,
    'city.exceedsMaxLength': cityNameExceeded,
    'zipcode.exceedsMaxLength': zipCodeExceeded,
    'senderName.exceedsMaxLength': senderNameExceeded,
    'recipientName.exceedsMaxLength': recipientNameExceeded
};

export default {
    paymentDeclined,
    transactionDeclined,
    limitReached,
    promoExpired,
    fieldError,
    idMapper
};
